import { noop } from 'underscore';
import { Status } from '../constants/status';

/* eslint-disable no-alert */
export function getToolbarConfig({
  i18n,
  isReadOnlyUser,
  onBulkEditAssetGroupsStatus,
  onCreateAssetGroup,
  onRequestException,
}) {
  const toolbarSelectedConfig = new Map([
    ['selection-widget', {
      type: 'selection-widget',
      onSelectCrossPage: noop,
    }],
    ['divider', {
      type: 'divider',
    }],
    ['dropdown-edit', {
      id: 'bulk-dropdown-edit',
      type: 'dropdown',
      button: {
        text: i18n.getString(_TL_('Edit')),
        classes: ['btn', 'btn-hero'],
      },
      disabled: isReadOnlyUser,
      iconLeftGlyphName: 'ba-Edit',
      menu: {
        items: [{
          text: i18n.getString(_TL_('Enable')),
          iconLeft: ['icon-status-enable'],
          iconLeftGlyphName: 'ba-RadioBullet2',
          classes: ['bulk-edit-enable'],
          onClick: () => onBulkEditAssetGroupsStatus(Status.Active),
        }, {
          text: i18n.getString(_TL_('Pause')),
          iconLeft: ['icon-status-pause'],
          iconLeftGlyphName: 'ba-PauseListView12',
          classes: ['bulk-edit-pause'],
          onClick: () => onBulkEditAssetGroupsStatus(Status.Paused),
        }, {
          text: i18n.getString(_TL_('Delete')),
          iconLeft: ['icon-status-delete'],
          iconLeftGlyphName: 'ba-Delete',
          classes: ['bulk-edit-delete'],
          onClick: () => onBulkEditAssetGroupsStatus(Status.Deleted),
        }, {
          text: i18n.getString(_TL_('Request exception')),
          classes: ['bulk-edit-request-exception'],
          onClick: () => onRequestException(),
        }],
      },
    }],
    ['expander', {
      type: 'expander',
    }],
    ['button-clear-selection', {
      type: 'button-clear-selection',
    }],
  ]);

  const toolbarUnselectedConfig = new Map([
    ['button-ad-create', {
      id: 'button-create',
      type: 'button',
      text: i18n.getString(_TL_('Create')),
      classes: ['btn-primary'],
      iconLeftGlyphName: 'ba-Add',
      noResponsive: true,
      onClick: onCreateAssetGroup,
    }],
    ['predicate-list', {
      id: 'predicate-list',
      type: 'custom',
    }],
    ['expander', {
      type: 'expander',
    }],
    ['dropdown-column-chooser', {
      id: 'dropdown-column-chooser',
      type: 'dropdown',
      iconLeftGlyphName: 'ba-TripleColumnSolid',
    }],
    ['Expand table', {
      type: 'expand-table',
    }],
  ]);

  return {
    toolbarSelectedConfig,
    toolbarUnselectedConfig,
  };
}
